import api from './api';
import { isTokenExpired, updateLastActivity } from './tokenUtils';

const setAuthToken = token => {
  if (token) {
    // Verify token is not expired before setting
    if (isTokenExpired(token)) {
      console.warn('setAuthToken: Attempted to set expired token');
      // Clear expired token
      delete api.defaults.headers.common['x-auth-token'];
      localStorage.removeItem('token');
      return false;
    }
    
    api.defaults.headers.common['x-auth-token'] = token;
    localStorage.setItem('token', token);
    // Update last activity when token is set
    updateLastActivity();
    return true;
  } else {
    delete api.defaults.headers.common['x-auth-token'];
    localStorage.removeItem('token');
    return false;
  }
};

export default setAuthToken;